import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* createCodeShipping({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.codes.create.free_shipping, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.createCodeShippingDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createCodeShippingFailed,
      handledErrors,
      endpoint: api.codes.create.free_shipping.url
    });
  }
}

export const createCodeShippingSaga = takeEvery(types.CREATE_CODE_SHIPPING_REQUEST, createCodeShipping);